// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    width: 100%;
    padding: 1.3rem 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    background-color: #27AE60;
}

.logo-container-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo-header {
    width: 25%;
}

.nav-links {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
}

.nav-link {
    display: flex;
    align-items: center;
    font-size: 1.15rem;
    color: #FFF;
    text-decoration: none;
    margin-left: 2.5rem;
}

.nav-link:hover {
    text-shadow: 0 0 5px #FFF;
}

.nav-link i {
    margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/css/sg-header.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".header {\n    width: 100%;\n    padding: 1.3rem 10%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n    background-color: #27AE60;\n}\n\n.logo-container-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.logo-header {\n    width: 25%;\n}\n\n.nav-links {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    list-style: none;\n}\n\n.nav-link {\n    display: flex;\n    align-items: center;\n    font-size: 1.15rem;\n    color: #FFF;\n    text-decoration: none;\n    margin-left: 2.5rem;\n}\n\n.nav-link:hover {\n    text-shadow: 0 0 5px #FFF;\n}\n\n.nav-link i {\n    margin-right: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
